module.exports = __webpack_public_path__ + "img/hallie-rubenhold.260d8eca.png";